module.exports = __webpack_public_path__ + "static/about-me-56a9914c5dbdfe56d4617a0fdf4039bc.jpg";